module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADEAAAAxBAMAAACBslwvAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAhUExURUdwTBdr9Rho9xhs9hZr9hdr9RZr9Q1l7Rdr9Rds9Rhs9XaBAmMAAAAKdFJOUwBfIH4/7VMN16/ncjdHAAAA5ElEQVQ4y2NgoAFgEUQCYg4ICbaoVchgBUJKahUqWAKTYI8KVEIGoivghq1yQLGVEcZn91yFZL8IAwPTKgGITCqqJS1wGUY061c5wGRKlyYhW68YFQCTyVqG6mupJTAZqwUMiVDbFRgYVBi0FiJk4DY1MDBEJSDLsMBkJjAwtDogyzAUQW0HeQ7FNFQXIMksFEQBVggZdJ8SI7MIJQqUvIhxwagMSTKw1Iwp47q0ALsMMIYYcMgsFcAhs1IcyspagiqD4FetQMlXLFHhMCYzegoRgKtCSzyBCP3swsZIwLCAYZAAAEkVu+YJBHOnAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/phoneHomePage/expand-2.png
// module id = J97D
// module chunks = 0